import { useDashboardSummary } from './lib/useDashboardSummary';
import React, { useState } from 'react';
import { Box, AlertTriangle, Maximize2 } from 'lucide-react';
import EstoqueTotal from './EstoqueTotal';


export default function Estoque({ pedidosCancelados, valordevolucoesMes, mostraFaturamento, mostraExpedicao, refreshSignal = 0, empresa = '' }) {





  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data, loading, error } = useDashboardSummary('/api/dashboard/Estoque', { empresa, refreshSignal });
  if (error) return <div role="alert" className="rounded border border-red-900 bg-[#161b22] p-4 text-xs text-red-300">{error}</div>;

  // Se estiver a carregar, exibe um estado visual simples para o card
  if (loading) {
    return (
      <div className="bg-[#161b22] border-l-4 border-green-500 p-5 rounded animate-pulse h-full">
        <div className="h-4 bg-gray-800 rounded w-1/2 mb-4"></div>
        <div className="h-8 bg-gray-800 rounded w-3/4"></div>
      </div>
    );
  }

  // Valores de fallback enquanto carrega ou se a API falhar
  const estoqueTotal = data?.estoqueTotal || 0;
  const estoqueTotalMinimo = data?.estoqueTotalMin || 0;
  const estoqueSemPedido = data?.estoqueSemPedido || 0;

  // Cálculo do percentual para o gráfico circular (Ex: 15k de 61k = ~24%)
  const percentualSemPedido = estoqueTotal > 0
    ? ((estoqueSemPedido / estoqueTotal) * 100).toFixed(2)
    : 0;

  if (loading) {
    return <div className="p-5 text-gray-500 font-mono text-xs animate-pulse text-center">CARREGANDO ESTOQUE...</div>;
  }

  return (
    <>
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
      {mostraExpedicao > 0 && (
        <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Card Valor Total de Estoque */}
          <div className="relative bg-[#161b22] p-5 pt-10 rounded border border-gray-800 flex flex-col justify-between shadow-xl">
            <StockExpandButton onExpand={() => setIsModalOpen(true)} />
            <div className="flex justify-between items-start">
              <div className="flex items-center gap-2 text-purple-400 font-bold text-[9px] uppercase tracking-widest">
                <Box size={18} /> <span>Estoque Preço de Tabela</span>
              </div>
              <span className="text-green-500  text-[14px] font-mono font-bold text-lg italic tracking-tighter">
                 {Number(estoqueTotal).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
              </span>
            </div>
            <div className="flex justify-between items-start">
              <div className="flex items-center gap-2 text-purple-400 font-bold text-[9px] uppercase tracking-widest">
                <Box size={18} /> <span>Estoque Preço Mínimo </span>
              </div>
              <span className="text-green-500  text-[14px] font-mono font-bold text-lg italic tracking-tighter">
                 {Number(estoqueTotalMinimo).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
              </span>
            </div>
            <div className="mt-6">
             
              <div className="w-full bg-gray-900 h-2 rounded-full overflow-hidden border border-gray-800">                
                <div                  
                  className="bg-gradient-to-r from-blue-600 to-orange-500 h-full transition-all duration-1000"
                  style={{ width: `${Math.round(100/*percentualSemPedido*/)}%` }}
                />
              </div>
            </div>
          </div>

          {/* Card Gráfico Circular (Percentual Sem Pedido) */}
          <div className="bg-[#161b22] p-3 rounded border border-gray-800 flex items-center justify-between shadow-xl">
            <div className="relative h-20 w-20 -rotate-90">
              <svg className="h-full w-full" viewBox="0 0 36 36">
                <circle
                  cx="18" cy="18" r="16" fill="none"
                  className="stroke-gray-800" strokeWidth="3.5"
                />
                <circle
                  cx="18" cy="18" r="16" fill="none"
                  className="stroke-orange-500 shadow-orange-500 transition-all duration-800"
                  strokeWidth="3.5"
                  strokeDasharray={`${percentualSemPedido}, 100`}
                  strokeLinecap="round"
                />
              </svg>
              <div className="absolute inset-0 flex items-center justify-center rotate-90">
                <span className="text-[11px] font-black text-orange-500 font-mono">
                  {Math.round(percentualSemPedido).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}%
                </span>
              </div>
            </div>
            <div className="text-right">
              <span className="text-gray-500 text-[10px] block font-bold uppercase mb-1 tracking-tighter">
                Sem Pedido
              </span>
              <p className="text-green-500 font-mono font-bold text-lg italic tracking-tighter">
                 {Number(estoqueSemPedido).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
              </p>
            </div>
          </div>
         
        </div>)}

      {/* --- SEÇÃO DIREITA: ALERTAS CRÍTICOS (4 COLUNAS) --- */}
      {mostraFaturamento > 0 && (
        <div className="lg:col-span-4 bg-[#1c1616] p-5 rounded border border-red-900/30 shadow-2xl">
          <div className="flex items-center gap-2 text-red-600 mb-6 font-black text-[10px] uppercase italic tracking-widest">
            <AlertTriangle size={16} /> <span>Alertas Críticos</span>
          </div>
          <div className="space-y-4">
            <AlertLine
              label="Pedidos cancelados no Mês"
              val={pedidosCancelados || 0}
              color="text-red-800"
            />
            <AlertLine
              label="Devoluções no Mês"
              val={valordevolucoesMes || 0}
              color="text-orange-800"
            />
          </div>
        </div>)}

    </div>
    {isModalOpen && mostraExpedicao > 0 && <EstoqueTotal data={data} empresa={empresa} onClose={() => setIsModalOpen(false)} />}
    </>
  );
}

/**
 * Subcomponente para formatar as linhas de alerta
 */
function AlertLine({ label, val, color }) {
  return (
    <div className="flex justify-between items-center text-[10px] border-b border-white/5 pb-2">
      <div className="flex items-center gap-2">
        <AlertTriangle size={12} className={color} />
        <span className="text-gray-400 font-bold uppercase tracking-tighter">{label}</span>
      </div>
      <span className="text-green-500 font-mono font-bold italic tracking-tighter">
        R$ {Number(val).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
      </span>
    </div>
  );
}

function StockExpandButton({ onExpand }) {
  return <button type="button" onClick={onExpand} aria-label="Abrir detalhes do estoque" title="Ver detalhes do estoque" className="absolute top-3 right-3 text-gray-600 hover:text-purple-400 transition-colors z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-purple-400">
    <Maximize2 aria-hidden="true" size={18} />
  </button>;
}
